import {
  Box,
  Card,
  Grid,
  IconButton,
  Stack,
  Typography,
  TextField,
  Tooltip,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Icon,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Tabs,
  Tab,
  Switch,
  FormGroup,
  FormControlLabel,
  FormLabel,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  FormHelperText,
  Autocomplete,
} from "@mui/material";
import CommonLayout from "layouts/DashboardLayout";
import React, { useCallback, useEffect, useRef, useState } from "react";
import MDButton from "components/MDButton";
import { openCustomModalDialog, setModalLoader } from "../../../redux/slices/modalSlice";
import { useDispatch } from "react-redux";
import AngleRightIcon from "common/customIcons/angle_right";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Link, useNavigate, useParams } from "react-router-dom";
import DeleteIcon from "common/customIcons/delete";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import CommonQuillEditor from "common/editor";
import TabContext from "@mui/lab/TabContext";
import { stateList } from "utilities/common";

import { cities } from "utilities/common/Cities";
import { getAllCategory } from "../../../redux/slices/hyperwolf/products";
import { useSelector } from "react-redux";
import PlusIcon from "common/customIcons/plus";
import { openSnackbar } from "../../../redux/slices/common";
import {
  CreateLocationHit,
  fetchSlug,
  getHomePageList,
  getLocationById,
  getStates,
} from "../../../redux/slices/homePage";
import { getData } from "utilities/common";
import { validateLocationPage } from "validations/hyperwolf/validateLocationPage";
import { uploadImage } from "../../../redux/slices/common";
import CloseIcon from "@mui/icons-material/Close";
import { slugRegexHypen } from "utilities/common";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { AgGridTable } from "components/tables/AgGridTable";
import NoDataFound from "common/component/NoDataFound";
import EditIcon from "common/customIcons/edit";
import ActiveIcon from "common/customIcons/active";
import InActiveIcon from "common/customIcons/inactive";
import { OpenInNewSharp } from "@mui/icons-material";
import colors from "assets/theme/base/colors";
import Loader from "common/Loader";
import { getHomePageStateList, getLocationPageCityList } from "../../../redux/slices/homePage";
import MDBox from "components/MDBox";
import { capitalizeText } from "utilities/common";
import TopSection from "./sections/top-section";
import HeroSection from "./sections/hero-section";
import CategorySection from "./sections/category-section";
import CustomerReview from "./sections/customer-review";
import FavDeliverySection from "./sections/fav-delivery-section";
import ContentSection from "./sections/content-section";
import FaqSection from "./sections/faq-section";
import BottomSection from "./sections/bottom-section";

const initialData = {
  status: "",
  stateName: "",
  stateCode: "",
  city: "",
  metaTitle: "",
  metaDescription: "",
  cityParagraph: "",
  heroSection: {
    title: "",
    heroSectionPara: "",
    banners: [],
  },
  categorySection: [
    {
      categoryName: "",
      bentoGridHeading: "",
      bentoGridHeading1: "",
      categoryHeading: "",
      layoutType: "No Grid",
      defaultRedirectUrlEnable: false,
      defaultGridUrl: "",
      desktopBanner: {
        imageUrl: "",
        title: "",
        description: "",
        altText: "",
        redirectUrl: "",
      },
      mobileBanner: {
        imageUrl: "",
        title: "",
        description: "",
        altText: "",
        redirectUrl: "",
      },
      desktopGrid: [],
      mobileGrid: [],
      arrayIndex: 0,
    },
  ],
  customerReviews: "",
  deliverySection: {
    sectionTitle: "",
    sectionPara: "",
    subData: [
      {
        image: null,
        heading: "",
        subHeading: "",
        paragraph: "",
        deliveryId: crypto.randomUUID(),
      },
    ],
  },
  faqSection: {
    title: "",
    subData: [
      {
        question: "",
        answer: "",
        faqId: crypto.randomUUID(),
      },
    ],
  },
  //   footerSection: {
  //     paragraph: `WARNING: CANNABIS IS A SCHEDULE I CONTROLLED SUBSTANCE. KEEP OUT OF REACH OF CHILDREN AND ANIMALS. CANNABIS PRODUCTS MAY ONLY BE POSSESSED OR CONSUMED BY PERSONS 21 YEARS OF AGE OR OLDER UNLESS THE PERSON IS A QUALIFIED MEDICINAL PATIENT. THE INTOXICATING EFFECTS OF CANNABIS PRODUCTS MAY BE DELAYED UP TO TWO HOURS. CANNABIS USE WHILE PREGNANT OR BREASTFEEDING MAY BE HARMFUL. CONSUMPTION OF CANNABIS PRODUCTS IMPAIRS YOUR ABILITY TO DRIVE AND OPERATE MACHINERY. PLEASE USE EXTREME CAUTION.

  // C.A. PROP 65 WARNING: PRODUCTS SOLD HERE EXPOSE YOU TO CHEMICALS INCLUDING TETRAHYDROCANNBINOL (THC), WHICH ARE KNOWN TO THE STATE OF CALIFORNIA TO CAUSE BITH DEFECTS OR OTHER REPRODUCTIVE HARM. FOR MORE INFORMATION GOT TO WWW.P65WARNINGS.CA.GOV

  // © HyperWolf 2025

  // 2023.06.15(0.1.0)`,
  //     locationList: [
  //       // {
  //       //   locationName: "",
  //       //   locationLink: "",
  //       //   location_id:"",
  //       // },
  //     ],
  //     menusItems: {
  //       overView: {
  //         name: "Overview",
  //         title: "Overview test",
  //         isActive: true,
  //         subData: {
  //           cta1: {
  //             label: "",
  //             url: "",
  //           },
  //           cta2: {
  //             label: "",
  //             url: "",
  //           },
  //           description: "",
  //         },
  //       },
  //       siteMap: {
  //         name: "Site Map",
  //         title: "Sitemap test",
  //         isActive: true,
  //         subData: [
  //           // { label: "Home", url: "/", icon: "" }
  //         ],
  //       },
  //       traits: {
  //         name: "Traits",
  //         title: "Traits test",
  //         isActive: true,
  //         subData: [
  //           // { label: "Home", url: "/", icon: "" }
  //         ],
  //       },
  //       findYourCareer: {
  //         name: "Find Your Career",
  //         title: "Career test",
  //         isActive: true,
  //         subData: [
  //           // { label: "Home", url: "/", icon: "" }
  //         ],
  //       },
  //       quickLinks: {
  //         name: "Quick Links",
  //         title: "quickLinks test",
  //         isActive: true,
  //         subData: [
  //           // { label: "Home", url: "/", icon: "" }
  //         ],
  //       },
  //     },
  //   },
  topSection: {
    pageTitle: "",
    subHeading: "",
    topDescription: "",
  },
  bottomSection: {
    description: "",
  },
};
const thumbnailCloseIcon = {
  backgroundColor: "#FD4438",
  borderRadius: 10,
  p: 0.25,
  mt: -4,
  mr: -4,
  cursor: "pointer",
};

export default function CreateLocation() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const mainGridApiRef = useRef("");
  const { locationId } = useParams();

  const pageRef = useRef(0);
  const gridRefApi = useRef(null);
  const { categories: allCategoryData = {} } = useSelector((state) => state.hyperwolfProducts);
  const {
    updateloading = false,
    // loading: getLoader = false,
    slugData,
  } = useSelector((state) => state.homePage);
  const [cardErrors, setCardErrors] = useState({});

  const user = getData("login-user-info");
  const parseUser = JSON.parse(user);
  const [errors, setErrors] = useState({});
  const [copyStatus, setCopyStatus] = useState("");
  const [gridMsg, setGridMsg] = useState("");
  const [productSlugData, setProductSlugData] = useState("");
  const [isProductSlug, setIsProductSlugData] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const gridConfigs = [
    { key: "Two Column-Left", value: 3 },
    { key: "Two Column-Right", value: 3 },
    { key: "Full Width", value: 1 },
    { key: "Stacked Grid", value: 3 },
    { key: "Two Column", value: 2 },
    { key: "Equal", value: 2 },
    { key: "Triple Grid", value: 3 },
    { key: "Slider", value: 3 },
  ];
  const [formData, setFormData] = useState({
    ...initialData,
    createdBy: parseUser?.name || "Admin",
    upddateBy: parseUser?.name || "Admin",
  });
  const { text } = colors;
  const thumbnail = {
    maxWidth: "100px",
    height: "70px",
    borderRadius: "6px",
    objectFit: "cover",
  };
  const linkStyle = {
    color: text.main,
    display: "inline-flex",
    alignItems: "center",
    gap: 4,
  };

  const [stateListss, setStateListss] = useState([]);
  const [cityListss, setCityListss] = useState([]);
  const { banners = {}, isLoading: loading = false } = useSelector((state) => state.common);
  const liveStates = useSelector((state) => state.homePage.liveStates);

  const getRows = async (params) => {
    gridRefApi.current = params;

    let sortInfo = null;
    if (params?.sortModel?.length) {
      sortInfo = getSortInfo(params.sortModel);
    }

    if (formData?.heroSection?.banners?.length > 0) {
      let rowData = formData.heroSection.banners.map((item) => ({
        ...item,
        desktop_image: item.desktop.imageFile || "",
        mobile_image: item.mobile.imageFile || "",
        url: item.destinationUrl || "",
        desktop_description: item.desktop.description || "",
        mobile_description: item.mobile.description || "",
        status: item.status === "active" ? "active" : "inactive",
        media_type: ["mp4", "webm"].includes(
          (item?.desktopImage?.split(".").pop() || "").toLowerCase()
        )
          ? "video"
          : "image",
        bannerId: item.bannerId,
      }));

      if (sortInfo) {
        rowData = sortLocalData(rowData, sortInfo);
      }

      return params.successCallback(rowData, rowData.length);
    }
  };
  const columnDefs = [
    {
      headerName: "Desktop Image/Video",
      field: "desktop_image",
      suppressMenu: false,
      flex: 1.25,
      sortable: false,
      minWidth: 160,
      cellRenderer: (props) => {
        const { data: item } = props;
        if (!item?.desktop_image) return null;
        return item?.mediaType === "video" ? (
          <video style={thumbnail} loop autoPlay playsInline muted>
            <source
              key={item.desktop_image}
              src={item.desktop_image}
              style={{ borderRadius: "10px" }}
              type="video/webm"
            />
              <source
              key={item.desktop_image}
              src={item.desktop_image}
              style={{ borderRadius: "10px" }}
              type="video/mp4"
            />
          </video>
        ) : (
          <img src={item.desktop_image} style={thumbnail} />
        );
      },
    },
    {
      headerName: "Mobile Image/Video",
      field: "mobile_image",
      suppressMenu: false,
      flex: 1.25,
      sortable: false,
      minWidth: 160,
      cellRenderer: (props) => {
        const { data: item } = props;
        if (!item?.mediaType) return null;
        return item?.mediaType === "video" ? (
          <video style={thumbnail} loop autoPlay playsInline muted>
            <source
              key={item.mobile_image}
              src={item.mobile_image}
              style={{ borderRadius: "10px" }}
              type="video/mp4"
            />
          </video>
        ) : (
          <img src={item.mobile_image} style={thumbnail} />
        );
      },
    },
    {
      headerName: "Destination URL",
      field: "url",
      flex: 1.75,
      sortable: false,
      minWidth: 220,
      suppressMenu: false,
      cellRenderer: (props) => {
        return props?.value ? (
          <Link target="_blank" style={linkStyle} to={props?.value}>
            {props?.value}
            <OpenInNewSharp />
          </Link>
        ) : (
          "-"
        );
      },
    },
    {
      headerName: "Mobile Description",
      field: "mobile_description",
      flex: 2,
      sortable: false,
      suppressMenu: true,
      wrapText: true,
      minWidth: 280,
      cellRenderer: (props) => {
        return props?.value ? (
          <Tooltip title={capitalizeText(props?.value)} arrow placement="top">
            <MDBox textAlign="left">
              <Typography
                variant="p"
                // color="dark"
                lineHeight={1.25}
                // fontWeight="semibold"
                className="text-14 truncate line-1"
              >
                {capitalizeText(props?.value)}
              </Typography>
            </MDBox>
          </Tooltip>
        ) : (
          "-"
        );
      },
    },
    {
      headerName: "Desktop Description",
      field: "desktop_description",
      flex: 2,
      sortable: false,
      suppressMenu: true,
      wrapText: true,
      minWidth: 280,
      cellRenderer: (props) => {
        return props?.value ? (
          <Tooltip title={capitalizeText(props?.value)} arrow placement="top">
            <MDBox textAlign="left">
              <Typography
                variant="p"
                color="dark"
                lineHeight={1.25}
                // fontWeight="semibold"
                className="text-14 truncate line-1"
              >
                {capitalizeText(props?.value)}
              </Typography>
            </MDBox>
          </Tooltip>
        ) : (
          "-"
        );
      },
    },
    {
      headerName: "Media Type",
      field: "mediaType",
      flex: 1,
      minWidth: 120,
      suppressMenu: false,
      cellRenderer: (props) => {
        return props?.value ? props.value : "-";
      },
    },
    {
      headerName: "Status",
      field: "status",
      flex: 1,
      minWidth: 100,
      suppressMenu: false,
      cellRenderer: (props) => {
        const status = props.value?.toLowerCase();

        const isActive = status === "active";

        return (
          <Box
            display="flex"
            alignItems="center"
            className="status-col"
            color={isActive ? "#24CA49" : "#FF4D4D"} // red for inactive
          >
            {isActive ? (
              <ActiveIcon width="18px" height="18px" flex="none" />
            ) : (
              <InActiveIcon width="18px" height="18px" flex="none" />
            )}

            <Typography variant="caption" fontWeight="regular" ml={0.5} textTransform="capitalize">
              {props.value}
            </Typography>
          </Box>
        );
      },
    },

    {
      headerName: "Actions",
      sortable: false,
      cellRenderer: (props) => {
        return (
          <Box display="inline-flex" alignItems="center">
            <IconButton
              onClick={(e) => {
                e.stopPropagation();
                onEditClicked(props.data); // send current row data
              }}
              color="primary"
              size="small"
              variant="primary"
            >
              <EditIcon width="16px" height="16px" />
            </IconButton>
            <IconButton
              onClick={(e) => {
                e.stopPropagation();
                deleteHandler(props.data?.bannerId);
                // dispatch(
                //   openCustomModalDialog({
                //     modalData: {
                //       deleteHandler,
                //       deleteId: props.data?.bannerId,
                //       deleteType: "banner",
                //     },
                //     modal: "DELETE_MODAL",
                //   })
                // );
              }}
              color="error"
              size="small"
              variant="primary"
              sx={{ marginLeft: 1 }}
            >
              <DeleteIcon width="16px" height="16px" />
            </IconButton>
          </Box>
        );
      },
      cellStyle: { textAlign: "right", justifyContent: "end" },
      headerClass: "right-aligned-cell-header",
      flex: 1,
      minWidth: 100,
      maxWidth: 120,
      pinned: "right",
    },
  ];

  useEffect(() => {
    if (mainGridApiRef?.current) {
      if (loading) {
        mainGridApiRef.current.showLoadingOverlay();
      } else if (banners?.total === 0) {
        mainGridApiRef.current.showNoRowsOverlay();
      } else {
        mainGridApiRef.current.hideOverlay();
      }
    }
  }, [banners, loading]);
  const deleteHandler = (bannerId) => {
    setFormData((prev) => ({
      ...prev,
      heroSection: {
        ...prev.heroSection,
        banners: prev.heroSection.banners.filter((b) => b.bannerId !== bannerId),
      },
    }));

    showError("Banner removed", "success");
  };
  const handleAddBanner = (banner) => {
    setFormData((prev) => ({
      ...prev,
      heroSection: {
        ...prev.heroSection,
        banners: [...prev.heroSection.banners, { ...banner, bannerId: crypto.randomUUID() }],
      },
    }));
    setErrors((prev) => ({ ...prev, heroBanners: "" }));
    if (formData?.heroSection?.banners?.length >= 3) {
      setErrors((prev) => ({ ...prev, heroBannersActive: "", heroBanners: "" }));
    }
  };
  const onEditClicked = (banner) => {
    dispatch(
      openCustomModalDialog({
        modal: "ADD_HOME_BANNER",
        modalData: {
          bannerData: banner,
          onSubmit: handleEditBanner,
        },
      })
    );
  };
  const handleEditBanner = (updatedBanner) => {
    setFormData((prev) => ({
      ...prev,
      heroSection: {
        ...prev.heroSection,
        banners: prev.heroSection.banners.map((banner) =>
          banner.bannerId === updatedBanner.bannerId ? updatedBanner : banner
        ),
      },
    }));
  };
  useEffect(() => {
    if (!mainGridApiRef.current) return;

    const ds = { getRows };
    mainGridApiRef.current.setDatasource(ds);
    mainGridApiRef.current.refreshInfiniteCache();
  }, [formData.heroSection.banners]);

  const sliderLength =
    formData?.categorySection?.[0]?.layoutType === "Slider"
      ? formData?.categorySection?.[0]?.desktopGrid?.length + 1
      : "";
  const sliderMobileLength =
    formData?.categorySection?.[0]?.layoutType === "Slider"
      ? formData?.categorySection?.[0]?.mobileGrid?.length + 1
      : "";

  const handleCopyLink = (Link) => {
    navigator.clipboard
      .writeText(Link)
      .then(() => {
        setCopyStatus("Copied!");
        setTimeout(() => setCopyStatus(""), 1000); // Clear message after 2 seconds
      })
      .catch(() => {
        setCopyStatus("Failed to copy");
        setTimeout(() => setCopyStatus(""), 1000); // Clear message after 2 seconds
      });
  };

  const handleAddCategory = () => {
    // Also add a new object (could be customized) into card?.categories array
    setFormData((prevFormData) => {
      const updatedFormData = { ...prevFormData };

      // If "categories" array doesn't exist, initialize it
      if (!Array.isArray(updatedFormData.categorySection)) {
        updatedFormData.categorySection = [];
      }

      updatedFormData.categorySection = [
        ...updatedFormData.categorySection,
        {
          categoryName: "",
          bentoGridHeading: "",
          layoutType: "No Grid",
          defaultRedirectUrlEnable: false,
          defaultGridUrl: "",
          desktopBanner: {
            imageUrl: "",
            title: "",
            description: "",
            altText: "",
            redirectUrl: "",
          },
          mobileBanner: {
            imageUrl: "",
            title: "",
            description: "",
            altText: "",
            redirectUrl: "",
          },
          desktopGrid: [],
          mobileGrid: [],
          arrayIndex: updatedFormData.categorySection.length,
        },
      ];

      return updatedFormData;
    });
  };
  const allCategoriesSelected =
    allCategoryData?.values?.length > 0 &&
    formData?.categorySection?.length >= allCategoryData?.values?.length;

  const handleRemoveCategory = (cardId) => {
    setFormData((prevFormData) => {
      const updatedFormData = { ...prevFormData };
      if (Array.isArray(updatedFormData.categorySection)) {
        // Remove category and reset arrayIndex based on new data set order
        const filteredSections = updatedFormData.categorySection
          .filter((cat) => cat.arrayIndex !== cardId)
          .map((cat, idx) => ({ ...cat, arrayIndex: idx }));
        updatedFormData.categorySection = filteredSections;
      }
      return updatedFormData;
    });

    setCardErrors((prevErrors) => {
      // Remove error entry for the removed card, and resequence errors to match new arrayIndex
      const updatedErrors = { ...prevErrors };
      // Remove the error corresponding to the removed card
      Object.keys(updatedErrors).forEach((key) => {
        // Remove error if the key matches either string or number (support both id and card-index style keys)
        if (key === `${cardId}` || key === `card-${cardId}`) {
          delete updatedErrors[key];
        }
      });

      // Get remaining keys and values for errors that match 'card-'
      const errorEntries = Object.entries(updatedErrors).filter(([key]) => /^card-\d+$/.test(key));
      // Sort by index to keep order
      errorEntries.sort((a, b) => {
        const aIdx = parseInt(a[0].split("-")[1]);
        const bIdx = parseInt(b[0].split("-")[1]);
        return aIdx - bIdx;
      });
      // Rebuild errors object with resequenced keys
      let newErrors = { ...updatedErrors };
      errorEntries.forEach(([key, val], idx) => {
        const newKey = `card-${idx}`;
        if (key !== newKey) {
          delete newErrors[key];
          newErrors[newKey] = val;
        }
      });

      return newErrors;
    });
  };

  // const handleSave = (data) => {
  //   if (typeof data?.arrayIndex === "number") {
  //     setFormData((prevFormData) => {
  //       const updatedFormData = { ...prevFormData };
  //       // Create a new categorySection array by mapping
  //       updatedFormData.categorySection = prevFormData.categorySection.map((section, idx) => {
  //         if (section.arrayIndex === data.arrayIndex) {
  //           // Update only the matching section by arrayIndex
  //           let updatedSection = { ...section };
  //           // Desktop/Mobile Banner update
  //           if (data?.categorybanner === "desktopBanner") {
  //             updatedSection.desktopBanner = {
  //               imageUrl: data.imageUrl || "",
  //               title: data.title || "",
  //               description: data.description || "",
  //               altText: data.altText || "",
  //               redirectUrl: data.redirectUrl || "",
  //             };
  //           } else if (data?.categorybanner === "mobileBanner") {
  //             updatedSection.mobileBanner = {
  //               imageUrl: data.imageUrl || "",
  //               title: data.title || "",
  //               description: data.description || "",
  //               altText: data.altText || "",
  //               redirectUrl: data.redirectUrl || "",
  //             };
  //           } else {
  //             // Save into desktopGrid or mobileGrid
  //             if (data?.type === "Dekstop") {
  //               if (!Array.isArray(updatedSection.desktopGrid)) {
  //                 updatedSection.desktopGrid = [];
  //               }
  //               updatedSection.desktopGrid = [...updatedSection.desktopGrid, data];
  //             } else {
  //               if (!Array.isArray(updatedSection.mobileGrid)) {
  //                 updatedSection.mobileGrid = [];
  //               }
  //               updatedSection.mobileGrid = [...updatedSection.mobileGrid, data];
  //             }
  //           }
  //           return updatedSection;
  //         }
  //         return section;
  //       });
  //       return updatedFormData;
  //     });
  //   }
  // };

  const handleSave = (data) => {
    if (typeof data?.arrayIndex !== "number") return;

    setFormData((prev) => {
      const updated = { ...prev };

      updated.categorySection = prev.categorySection.map((section) => {
        if (section.arrayIndex !== data.arrayIndex) return section;

        const updatedSection = { ...section };

        // 🔹 Desktop Banner
        if (data.categorybanner === "desktopBanner") {
          updatedSection.desktopBanner = {
            imageUrl: data.imageUrl,
            title: data.title,
            description: data.description,
            altText: data.altText,
            redirectUrl: data.redirectUrl,
          };
          return updatedSection;
        }

        // 🔹 Mobile Banner
        if (data.categorybanner === "mobileBanner") {
          updatedSection.mobileBanner = {
            imageUrl: data.imageUrl,
            title: data.title,
            description: data.description,
            altText: data.altText,
            redirectUrl: data.redirectUrl,
          };
          return updatedSection;
        }

        // 🔹 GRID UPDATE (THIS WAS THE BUG)
        if (data.type === "Dekstop") {
          const grid = Array.isArray(updatedSection.desktopGrid)
            ? [...updatedSection.desktopGrid]
            : [];

          const idx = grid.findIndex((i) => i.index === data.index);

          if (idx > -1) {
            grid[idx] = data; // ✅ UPDATE
          } else {
            grid.push(data); // ➕ ADD
          }

          updatedSection.desktopGrid = grid;
        } else {
          const grid = Array.isArray(updatedSection.mobileGrid)
            ? [...updatedSection.mobileGrid]
            : [];

          const idx = grid.findIndex((i) => i.index === data.index);

          if (idx > -1) {
            grid[idx] = data; // ✅ UPDATE
          } else {
            grid.push(data); // ➕ ADD
          }

          updatedSection.mobileGrid = grid;
        }

        return updatedSection;
      });

      return updated;
    });
  };

  const removeImageHandler = (itemToRemove, gridType, arrayIndex) => {
    if (!itemToRemove || !itemToRemove.index || arrayIndex === undefined) return;

    setFormData((prevFormData) => {
      const updatedCategorySection = prevFormData.categorySection.map((section, idx) => {
        if (idx !== arrayIndex) return section;

        let updatedSection = { ...section };
        if (gridType === "mobileGrid") {
          if (Array.isArray(updatedSection.mobileGrid)) {
            updatedSection.mobileGrid = updatedSection.mobileGrid.filter(
              (item) => item.index !== itemToRemove.index
            );
          }
        } else {
          if (Array.isArray(updatedSection.desktopGrid)) {
            updatedSection.desktopGrid = updatedSection.desktopGrid.filter(
              (item) => item.index !== itemToRemove.index
            );
          }
        }
        return updatedSection;
      });

      return {
        ...prevFormData,
        categorySection: updatedCategorySection,
      };
    });
  };

  useEffect(() => {
    dispatch(getAllCategory());
  }, []);

  const handleSubmitButton = (status) => {
    if (status === "published") {
      const { errors, isValid } = validateLocationPage(formData);
      setErrors(errors);
      if (!isValid) {
        // Scroll to the first error field
        const firstErrorField = Object.keys(errors)[0];
        showError(errors[firstErrorField], "error");

        if (firstErrorField) {
          // Wait for DOM to be ready and errors to render
          setTimeout(() => {
            const element = document.querySelector(`[name="${firstErrorField}"]`);

            if (firstErrorField === "stateName" || firstErrorField === "city") {
              window.scrollTo({ top: 0, behavior: "smooth" });
              return;
            }

            if (element) {
              // Scroll with offset for headers
              const yOffset = -120; // Adjust based on your header height
              const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;

              window.scrollTo({ top: y, behavior: "smooth" });

              // Focus the element
              element.focus({ preventScroll: true });
            } else {
              console.warn(`Element with name="${firstErrorField}" not found`);
            }
          }, 100); // Small delay to ensure DOM updates
        }
        // showError('Please fix the validation errors before submitting', 'error');
        return;
      }
    }

    // const hasGridErrors = Object.values(cardErrors).some((error) => error);
    // if (hasGridErrors) {
    //   // showError('Please fix all image validation errors before submitting', 'error');
    //   return;
    // }

    const payload = {
      ...formData,
      status: status,
    };
    if (locationId) {
      delete payload.createdBy;
    } else {
      delete payload.upddateBy;
    }

    if (isProductSlug) {
      payload.slug = productSlugData;
    } else {
      delete payload.slug;
    }

    dispatch(CreateLocationHit({ payload, locationId }))
      .unwrap()
      .then((res) => {
        dispatch(getLocationById(locationId));

        showError(res?.message, "success");
        navigate(-1);
      })
      .catch((err) => {
        showError(err?.message, "error");
      });
  };

  const showError = (message, errortype) => {
    if (errortype === "success") {
      dispatch(openSnackbar({ content: message, color: "success", icon: "check" }));
    }
    if (errortype === "error") {
      dispatch(openSnackbar({ content: message, color: "error", icon: "warning" }));
    }
  };

  useEffect(() => {
    if (locationId) {
      dispatch(getLocationById(locationId))
        .unwrap()
        .then((res) => {
          // Ensure arrayIndex is present and sequenced in each element of categorySection

          if (res) {
            const updatedCategorySection = Array.isArray(res.categorySection)
              ? res.categorySection.map((section, idx) => {
                // add type:"Dekstop" to desktopGrid, type:"Mobile" to mobileGrid elements
                const desktopGrid = Array.isArray(section.desktopGrid)
                  ? section.desktopGrid.map((el) => ({
                    ...el,
                    type: "Dekstop",
                  }))
                  : [];
                const mobileGrid = Array.isArray(section.mobileGrid)
                  ? section.mobileGrid.map((el) => ({
                    ...el,
                    type: "Mobile",
                  }))
                  : [];
                return {
                  ...section,
                  arrayIndex: typeof section.arrayIndex === "number" ? section.arrayIndex : idx,
                  desktopGrid,
                  mobileGrid,
                };
              })
              : [];

            // ⭐ Add UUID to banners (safe)
            const bannersWithIds = (res.heroSection?.banners || []).map((b) => ({
              ...b,
              bannerId: crypto.randomUUID(),
            }));
            const deliveryWithId = (res.deliverySection?.subData || []).map((b) => ({
              ...b,
              deliveryId: crypto.randomUUID(),
            }));
            const faqWithId = (res.faqSection?.subData || []).map((b) => ({
              ...b,
              faqId: crypto.randomUUID(),
            }));

            // const menusItemsWithIds = Object.fromEntries(
            //   Object.entries(res.footerSection?.menusItems || {}).map(([key, menu]) => {
            //     const { subData, ...restMenu } = menu;

            //     // ⭐ CASE 1: overView → subData is OBJECT
            //     if (key === "overView") {
            //       return [
            //         key,
            //         {
            //           ...restMenu,
            //           subData: {
            //             cta1: {
            //               label: subData?.cta1?.label || "",
            //               url: subData?.cta1?.url || "",
            //             },
            //             cta2: {
            //               label: subData?.cta2?.label || "",
            //               url: subData?.cta2?.url || "",
            //             },
            //             description: subData?.description || "",
            //           },
            //         },
            //       ];
            //     }

            //     // ⭐ CASE 2: other menus → subData is ARRAY
            //     return [
            //       key,
            //       {
            //         ...restMenu,
            //         subData: (subData || []).map((item) => ({
            //           ...item,
            //           itemId: crypto.randomUUID(),
            //         })),
            //       },
            //     ];
            //   })
            // );
            // setFormData({
            //   ...res,
            //   categorySection: updatedCategorySection,
            //   // categorySection:datsssssssssssa
            // });
            setFormData({
              ...res,
              heroSection: {
                ...res.heroSection,
                banners: bannersWithIds,
              },
              deliverySection: {
                ...res.deliverySection,
                subData: deliveryWithId,
              },
              faqSection: {
                ...res.faqSection,
                subData: faqWithId,
              },
              // footerSection: {
              //   ...res.footerSection,
              //   menusItems: menusItemsWithIds,
              //   locationList: res?.footerSection?.locationList?.map((item) => {
              //     return {
              //       ...item,
              //       location_id: item._id,
              //     };
              //   }),
              // },
              categorySection: updatedCategorySection,
            });
            setProductSlugData(res?.slug);
          }
        })
        .catch((err) => {
        });
    }
  }, [locationId]);

  // In your parent component:
  const handleGridError = React.useCallback((cardId, error) => {

    setCardErrors((prev) => {
      // Only update if the error actually changed
      if (prev[cardId] === error) return prev;
      return {
        ...prev,
        [cardId]: error,
      };
    });
  }, []);

  const handleChangeSlug = (e) => {
    const value = e.target.value;
    setIsProductSlugData(true);
    setProductSlugData(slugRegexHypen(value));
  };

  const slugGet = (city) => {
    const payload = {
      stateCode: formData?.stateCode,
      city: city,
    };
    dispatch(fetchSlug(payload))
      .unwrap()
      .then((res) => {
        setProductSlugData(res?.slug);
        // setFormData((prev) => ({
        //   ...prev,
        //   slug: res?.slug
        // }));
      })
      .catch((err) => {
        setErrors((prev) => ({
          ...prev,
          city: err?.message,
        }));
        setProductSlugData("");
      });
  };

  const handleRemoveDelivery = (indexToRemove) => {
    setErrors((prev) => ({
      ...prev,
      [`deliverySubData_${indexToRemove}_paragraph`]: "",
      [`deliverySubData_${indexToRemove}_heading`]: "",
      [`deliverySubData_${indexToRemove}_subHeading`]: "",
      [`deliverySubData_${indexToRemove}_image`]: "",
    }));
    setFormData((prev) => ({
      ...prev,
      deliverySection: {
        ...prev.deliverySection,
        subData: prev.deliverySection.subData.filter((_item) => _item.deliveryId !== indexToRemove),
      },
    }));
  };
  const handleFileChange = async (event, deliveryId) => {
    const selectedFile = event.target.files?.[0];
    if (!selectedFile) return;

    // Allow only images
    if (!selectedFile.type.startsWith("image/")) {
      alert("Please upload a valid image file.");
      return;
    }

    const body = new FormData();
    body.append("filePath", selectedFile);

    try {
      // Optional: show loader
      dispatch(setModalLoader(true));

      // Upload the image
      const res = await dispatch(uploadImage(body)).unwrap();

      // Update the form data for the deliverySection
      setFormData((prev) => {
        const updatedSubData = prev.deliverySection.subData.map((item) => {
          // Update the image of the item that matches the index (or another identifier)
          if (item.deliveryId === deliveryId) {
            return { ...item, image: res.fileUrl };
          }
          return item;
        });

        return {
          ...prev,
          deliverySection: {
            ...prev.deliverySection,
            subData: updatedSubData, // Update the subData with new image
          },
        };
      });
    } catch (err) {
      alert("Image upload failed. Try again.");
    } finally {
      dispatch(setModalLoader(false));
    }
  };
  const updateDeliveryField = (deliveryId, key, value) => {
    setFormData((prev) => ({
      ...prev,
      deliverySection: {
        ...prev.deliverySection,
        subData: prev.deliverySection.subData.map((sub) =>
          sub.deliveryId === deliveryId ? { ...sub, [key]: value } : sub
        ),
      },
    }));
  };
  const handleDelivery = () => {
    const deliveryErrors = validateDeliveryItems(formData.deliverySection?.subData);

    // ❌ Stop adding if any existing delivery item has errors
    if (Object.keys(deliveryErrors).length > 0) {
      setErrors((prev) => ({ ...prev, ...deliveryErrors }));

      const firstErrorField = Object.keys(deliveryErrors)[0];

      setTimeout(() => {
        const element = document.querySelector(`[name="${firstErrorField}"]`);

        if (element) {
          const yOffset = -120;
          const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;

          window.scrollTo({ top: y, behavior: "smooth" });
          element.focus({ preventScroll: true });
        }
      }, 100);

      return; // 🚫 DO NOT ADD DELIVERY CARD
    }

    // ✅ All existing delivery items are valid → add new one
    setFormData((prev) => ({
      ...prev,
      deliverySection: {
        ...prev.deliverySection,
        subData: [
          ...prev.deliverySection.subData,
          {
            image: "",
            heading: "",
            subHeading: "",
            paragraph: "",
            deliveryId: crypto.randomUUID(),
          },
        ],
      },
    }));
  };
  const handleRemoveFaq = (indexToRemove) => {
    setErrors((prev) => ({
      ...prev,
      [`errors_${indexToRemove}_answer`]: "",
      [`errors_${indexToRemove}_answer`]: "",
    }));
    setFormData((prev) => ({
      ...prev,
      faqSection: {
        ...prev.faqSection,
        subData: prev.faqSection.subData.filter((_item) => _item.faqId !== indexToRemove),
      },
    }));
  };
  const updateFaqField = (index, key, value) => {
    setFormData((prev) => ({
      ...prev,
      faqSection: {
        ...prev.faqSection,
        subData: prev.faqSection.subData.map((item) =>
          item.faqId === index ? { ...item, [key]: value } : item
        ),
      },
    }));
  };
  const handleAddFaq = () => {
    const faqErrors = validateFaqItems(formData.faqSection?.subData);

    // ❌ Stop adding if any FAQ has empty question/answer
    if (Object.keys(faqErrors).length > 0) {
      setErrors((prev) => ({ ...prev, ...faqErrors }));

      const firstErrorField = Object.keys(faqErrors)[0];

      setTimeout(() => {
        const element = document.querySelector(`[name="${firstErrorField}"]`);

        if (element) {
          const yOffset = -120;
          const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;

          window.scrollTo({ top: y, behavior: "smooth" });
          element.focus({ preventScroll: true });
        }
      }, 100);

      return; // 🚫 DO NOT ADD FAQ
    }

    // ✅ All previous FAQs valid → add new one
    setFormData((prev) => ({
      ...prev,
      faqSection: {
        ...prev.faqSection,
        subData: [
          ...prev.faqSection.subData,
          {
            question: "",
            answer: "",
            faqId: crypto.randomUUID(),
          },
        ],
      },
    }));
  };
  const validateFaqItems = (subData = []) => {
    const errors = {};

    const isQuillEmpty = (val = "") => {
      const v = val.trim();
      return v === "" || v === "<p><br></p>" || v === "<br>" || v === "<p></p>";
    };

    subData.forEach((item) => {
      if (isQuillEmpty(item.question)) {
        errors[`faq_${item.faqId}_question`] = "Question in FAQ section is required";
      }

      if (isQuillEmpty(item.answer)) {
        errors[`faq_${item.faqId}_answer`] = "Answer in FAQ section is required";
      }
    });

    return errors;
  };
  const validateDeliveryItems = (subData = []) => {
    const errors = {};

    subData.forEach((item) => {
      if (!item.image?.trim()) {
        errors[`deliverySubData_${item.deliveryId}_image`] = "Delivery section icon is required";
      }

      if (!item.heading?.trim()) {
        errors[`deliverySubData_${item.deliveryId}_heading`] =
          "Heading in delivery section item is required";
      }

      if (!item.subHeading?.trim()) {
        errors[`deliverySubData_${item.deliveryId}_subHeading`] =
          "Sub-heading in delivery section item is required";
      }

      if (!item.paragraph?.trim()) {
        errors[`deliverySubData_${item.deliveryId}_paragraph`] =
          "Paragraph in delivery section item is required";
      }
    });

    return errors;
  };

  const [topSectionOpen, setTopSectionOpen] = useState(false);
  const [categoryOpen, setCategoryOpen] = useState(false);
  const [bottomSectionOpen, setBottomSectionOpen] = useState(false);
  const [heroOpen, setHeroOpen] = useState(false);
  const [reviewOpen, setReviewOpen] = useState(false);
  const [deliveryOpen, setDeliveryOpen] = useState(false);
  const [faqOpen, setFaqOpen] = useState(false);
  // const [footerOpen, setFooterOpen] = useState(false);
  const [contentOpen, setContentOpen] = useState(false);

  useEffect(() => {
    // stringify to scan deeply
    const hasTopSectionError = Object.entries(errors).some(
      ([key, value]) => key.startsWith("topSection") && value?.trim()
    );

    const hasBottomSectionError = Object.entries(errors).some(
      ([key, value]) => key.startsWith("bottomSection") && value?.trim()
    );

    const hasHeroError = Object.entries(errors).some(
      ([key, value]) => key.startsWith("hero") && value?.trim()
    );
    const hasCategoryError = Object.entries(errors).some(
      ([key, value]) => key.startsWith("category") && value?.trim()
    );
    const hasReviewError = Object.entries(errors).some(
      ([key, value]) => key.startsWith("customer") && value?.trim()
    );
    const hasDeliveryError = Object.entries(errors).some(
      ([key, value]) => key.startsWith("delivery") && value?.trim()
    );
    const hasContentError = Object.entries(errors).some(
      ([key, value]) => key.startsWith("cityPara") && value?.trim()
    );
    const hasFaqError = Object.entries(errors).some(
      ([key, value]) => key.startsWith("faq") && value?.trim()
    );
    const hasFooterError = Object.entries(errors).some(
      ([key, value]) => key.startsWith("overView") || (key.startsWith("location") && value?.trim())
    );

    if (hasTopSectionError) setTopSectionOpen(true);
    if (hasCategoryError) setCategoryOpen(true);
    if (hasBottomSectionError) setBottomSectionOpen(true);
    if (hasHeroError) setHeroOpen(true);
    if (hasContentError) {
      setContentOpen(true);
    }
    if (hasReviewError) setReviewOpen(true);

    if (hasDeliveryError) setDeliveryOpen(true);

    if (hasFaqError) setFaqOpen(true);

    if (hasFooterError) setFooterOpen(true);
  }, [errors]);


  // useEffect(() => {
  //   dispatch(
  //     getHomePageStateList({
  //       skip: pageRef.current,
  //       limit: 10,
  //     })
  //   )
  //     .unwrap()
  //     .then((res) => {
  //       pageRef.current = pageRef.current + 10;
  //       const mappedStates = (res?.data || []).map((item) => ({
  //         value: item.stateName.toLowerCase().replace(/\s+/g, "_"),
  //         label: item.stateName,
  //         stateCode: item.stateCode,
  //         _id: item._id,
  //       }));

  //       setStateListss(mappedStates);
  //     });
  // }, []);

  useEffect(() => {
    dispatch(getStates({ limit: 1000 }))
      .unwrap()
      .then((res) => {
        const liveStates1 = (res?.data || []).map((item) => ({
          label: item.stateName,
          stateCode: item.stateCode,
        }));
        setStateListss(liveStates1);
      });
  }, []);
  useEffect(() => {
    dispatch(getLocationPageCityList())
      .unwrap()
      .then((res) => {
        const data = res?.data;
        setCityListss(data);
      });
  }, [formData.stateCode]);

  const onImageClicked = (catergoryData, type, dimensions, index, arrayIndex) => {
    dispatch(
      openCustomModalDialog({
        modal: "ADD_GRID_BANNER",
        modalData: {
          categoryData: categoryData,
          type: "Dekstop",
          dimensions: "386x600",
          index: "1",
          arrayIndex: card?.arrayIndex,
          handleSave: (data) => handleSave(data),
        },
      })
    );
  };

  return (
    <CommonLayout>
      {/* {getLoader ? (
        <Loader />
      ) : ( */}
      <Grid item xs={12} sm={4} md={2} xxl={2} className="static-pages-container">
        <Box p={{ xs: 2, sm: 3, lg: 4 }} style={{ paddingBottom: 0 }}>
          <Box display="flex" alignItems="center" justifyContent="space-between" mb={2}>
            <Box display="flex" alignItems="center" color="text.main" lineHeight={1}>
              <span
                style={{ cursor: "pointer", display: "flex", alignItems: "center" }}
                onClick={() => {
                  navigate(-1);
                }}
              >
                <AngleRightIcon fontSize="14px" />
                <Typography variant="h6" fontWeight="semibold" ml={0.75}>
                  City Page
                </Typography>
              </span>
            </Box>
          </Box>

          {/********************** Page Title **********************/}
          <Card sx={{ p: { xs: 2, md: 3 }, mb: 2, borderRadius: 2.5, boxShadow: "none" }}>
            <Box display="flex" alignItems="center" justifyContent="space-between">
              <Typography variant="h4" color="#9A9AAF" fontWeight="semibold" name="stateName">
                {locationId ? "Update" : "Add"} {locationId ? formData?.city || "City" : "City"}
              </Typography>
              {locationId && formData?.canonical && (
                <Box
                  display="flex"
                  sx={{ cursor: "pointer" }}
                  alignItems="center"
                  color="text.main"
                  lineHeight={1}
                  gap={2}
                  style={{ position: "relative" }}
                >
                  <Tooltip title={copyStatus ? copyStatus : "Copy"} arrow>
                    <IconButton
                      onClick={() => handleCopyLink(formData?.canonical)}
                      size="small"
                      sx={{ color: "primary.main" }}
                    >
                      <ContentCopyIcon fontSize="small" />
                    </IconButton>
                  </Tooltip>

                  <Typography
                    variant="body"
                    component="a"
                    href={formData?.canonical}
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{ textDecoration: "none", color: "inherit" }}
                    style={{
                      borderRadius: "26px",
                      color: "#0163FF",
                      fontSize: "14px",
                      fontWeight: "600",
                      border: "1px solid #0163FF",
                      padding: "10px 16px",
                    }}
                  >
                    {formData?.canonical}
                  </Typography>
                </Box>
              )}
            </Box>
          </Card>

          {/********************** Content Section **********************/}
          <Card sx={{ p: { xs: 2, md: 3 }, mb: 2, borderRadius: 2.5, boxShadow: "none" }}>
            <Grid container spacing={3}>
              <Grid item xs={12} md={4}>
                {/* <Typography variant='body2' fontWeight="medium" color="#9A9AAF" mb={1} style={{ fontSize: "14px" }}>Select State</Typography> */}

                {/* <FormControl fullWidth>
                  <InputLabel>Select State</InputLabel> */}
                {/* <Select
                    className="form-select stateName-1"
                    label="Select State"
                    value={formData.stateCode || ""}
                    disabled={!!locationId}
                    name="stateName"
                    onChange={(e) => {
                      const selectedStateCode = e.target.value;
                      const selectedState = stateList?.find(
                        (item) => item.stateCode === selectedStateCode
                      );
                      setFormData((prev) => ({
                        ...prev,
                        stateName: selectedState?.label || "",
                        stateCode: selectedState?.stateCode || "",
                        city: "",
                      }));
                      setErrors({
                        ...errors,
                        stateName: "",
                      });
                    }}
                  >
                    {stateList?.map((item, index) => (
                      <MenuItem key={index} value={item.stateCode}>
                        {item.label}
                      </MenuItem>
                    ))}
                  </Select> */}
                {/* {Boolean(errors?.stateName) && (
                    <FormHelperText error>{errors?.stateName}</FormHelperText>
                  )}
                </FormControl> */}

                {/* ///////// */}
                {/* ******  adding auto complete */}
                {/* ////////// */}

                <FormControl fullWidth>
                  <Autocomplete
                    // options={stateListss || []}
                    options={
                      // stateListss.filter((state) =>
                      //   liveStates.some((live) => live.stateCode === state.stateCode)
                      // ) || []
                      stateListss || []
                    }
                    // options={stateListss.filter((state) =>
                    //   liveStates.some((code) => code === state.stateCode)
                    // )}
                    getOptionLabel={(option) => option?.label || ""}
                    value={
                      stateListss?.find((item) => item.stateCode === formData.stateCode) || null
                    }
                    disabled={!!locationId}
                    isOptionEqualToValue={(option, value) => option.stateCode === value.stateCode}
                    onChange={(event, newValue) => {
                      setFormData((prev) => ({
                        ...prev,
                        stateName: newValue?.label || "",
                        stateCode: newValue?.stateCode || "",
                      }));
                    }}
                    renderInput={(params) => <TextField {...params} label="Select State" />}
                  />
                  {Boolean(errors?.stateName) && (
                    <FormHelperText error>{errors?.stateName}</FormHelperText>
                  )}
                </FormControl>
              </Grid>

              <Grid item xs={12} md={4}>
                {/* <Typography variant='body2' fontWeight="medium" color="#9A9AAF" mb={1} style={{ fontSize: "14px" }}>Add City Name</Typography> */}
                <FormControl fullWidth>
                  {/* <InputLabel>Select City</InputLabel> */}

                  {
                    <Autocomplete
                      className="form-select"
                      name="city"
                      options={
                        cityListss.filter((city) => city.stateCode === formData.stateCode) || []
                      }
                      getOptionLabel={(option) => option.city || ""}
                      value={cityListss.find((city) => city.city === formData.city) || null}
                      isOptionEqualToValue={(option, value) => option.city === value.city}
                      // disabled={!formData?.stateCode}
                      disabled={!formData?.stateCode || !!locationId}
                      onChange={(event, newValue) => {
                        if (newValue && newValue.city) {
                          slugGet(newValue.city);
                          setFormData((prev) => ({
                            ...prev,
                            city: newValue.city,
                          }));
                        } else {
                          setFormData((prev) => ({
                            ...prev,
                            city: "",
                          }));
                        }
                        setErrors({
                          ...errors,
                          city: "",
                        });
                      }}
                      renderInput={(params) => (
                        <TextField {...params} label="Select City" name="selectCity" />
                      )}
                    />
                  }

                  {Boolean(errors?.city) && <FormHelperText error>{errors?.city}</FormHelperText>}
                </FormControl>
              </Grid>

              <Grid item xs={12} md={4}>
                <TextField
                  className="form-input"
                  fullWidth
                  disabled={!formData?.city}
                  label="Location Slug"
                  name="productSlug"
                  value={productSlugData}
                  onChange={handleChangeSlug}
                />
              </Grid>
            </Grid>
          </Card>

          {/********************** Meta Tags **********************/}
          <Card sx={{ p: { xs: 2, md: 3 }, mb: 2, borderRadius: 2.5, boxShadow: "none" }}>
            <Typography variant="h5" fontWeight="semibold" mb={2}>
              Meta Properties
            </Typography>
            <Grid container spacing={3}>
              <Grid item xs={12} md={6}>
                <TextField
                  label="Meta Title"
                  className="form-input"
                  fullWidth
                  placeholder=""
                  name="metaTitle"
                  value={formData.metaTitle || ""}
                  error={errors.metaTitle}
                  helperText={errors?.metaTitle}
                  onChange={(e) => {
                    const metaTitle = e.target.value;
                    setFormData((prev) => ({
                      ...prev,
                      metaTitle,
                    }));
                    setErrors({
                      ...errors,
                      metaTitle: "",
                    });
                  }}
                />
                <span className="drag_drop">
                  Character Count: {formData.metaTitle ? formData.metaTitle.length : 0}{" "}
                  <span>(Recommended Characters: 60)</span>
                </span>
              </Grid>
              <Grid item xs={12} md={12}>
                <TextField
                  label="Meta Description"
                  className="form-input"
                  fullWidth
                  placeholder=""
                  name="metaDescription"
                  error={errors.metaDescription}
                  helperText={errors?.metaDescription}
                  value={formData.metaDescription || ""}
                  onChange={(e) => {
                    const metaDescription = e.target.value;
                    setFormData((prev) => ({
                      ...prev,
                      metaDescription,
                    }));
                    setErrors({
                      ...errors,
                      metaDescription: "",
                    });
                  }}
                />
                <span className="drag_drop">
                  Character Count: {formData.metaDescription ? formData.metaDescription.length : 0}{" "}
                  <span>(Recommended Characters: 160)</span>
                </span>
              </Grid>
            </Grid>
          </Card>

          {/********************** Top Section **********************/}

          <TopSection
            formData={formData}
            setFormData={setFormData}
            errors={errors}
            setErrors={setErrors}
            topSectionOpen={topSectionOpen}
            setTopSectionOpen={setTopSectionOpen}
          />

          {/********************** Hero Section **********************/}
          <HeroSection
            formData={formData}
            setFormData={setFormData}
            errors={errors}
            setErrors={setErrors}
            heroOpen={heroOpen}
            setHeroOpen={setHeroOpen}
            mainGridApiRef={mainGridApiRef}
            pageRef={pageRef}
            loading={loading}
            columnDefs={columnDefs}
            getRows={getRows}
            handleAddBanner={handleAddBanner}
            dispatch={dispatch}
          />

          {/********************** Category Section **********************/}
          <CategorySection
            formData={formData}
            setFormData={setFormData}
            errors={errors}
            setErrors={setErrors}
            categoryOpen={categoryOpen}
            setCategoryOpen={setCategoryOpen}
            handleRemoveCategory={handleRemoveCategory}
            handleAddCategory={handleAddCategory}
            allCategoriesSelected={allCategoriesSelected}
            gridConfigs={gridConfigs}
            removeImageHandler={removeImageHandler}
            dispatch={dispatch}
            sliderLength={sliderLength}
            sliderMobileLength={sliderMobileLength}
            allCategoryData={allCategoryData}
            handleSave={handleSave}
          />

          {/********************** Customer Reviews Section **********************/}
          <CustomerReview
            formData={formData}
            setFormData={setFormData}
            errors={errors}
            setErrors={setErrors}
            reviewOpen={reviewOpen}
            setReviewOpen={setReviewOpen}
          />

          {/********************** California's Favorite Cannabis Delivery Section **********************/}
          <FavDeliverySection
            formData={formData}
            setFormData={setFormData}
            errors={errors}
            setErrors={setErrors}
            deliveryOpen={deliveryOpen}
            setDeliveryOpen={setDeliveryOpen}
            handleDelivery={handleDelivery}
            handleRemoveDelivery={handleRemoveDelivery}
            handleFileChange={handleFileChange}
            locationId={locationId}
          />

          {/* ****************** Content added ******************** */}
          <ContentSection
            formData={formData}
            setFormData={setFormData}
            errors={errors}
            setErrors={setErrors}
            contentOpen={contentOpen}
            setContentOpen={setContentOpen}
          />

          {/********************** FAQ **********************/}

          <FaqSection
            formData={formData}
            setFormData={setFormData}
            errors={errors}
            setErrors={setErrors}
            faqOpen={faqOpen}
            setFaqOpen={setFaqOpen}
            handleAddFaq={handleAddFaq}
            handleRemoveFaq={handleRemoveFaq}
            updateFaqField={updateFaqField}
          />

          {/********************** Bottom Section **********************/}
          <BottomSection
            formData={formData}
            setFormData={setFormData}
            errors={errors}
            setErrors={setErrors}
            bottomSectionOpen={bottomSectionOpen}
            setBottomSectionOpen={setBottomSectionOpen}
          />

          <Stack direction={{ xs: "column", sm: "row" }} spacing={1.25} my={4}>
            <MDButton
              sx={{ minWidth: "160px" }}
              type="button"
              variant="contained"
              color="primary"
              onClick={() => handleSubmitButton("published")}
              disabled={updateloading || Boolean(errors?.city)}
            >
              {updateloading ? "Loading..." : locationId ? "Publish" : "Save"}
            </MDButton>
            <MDButton
              sx={{ minWidth: "160px" }}
              type="button"
              variant="outlined"
              color="dark"
              disabled={Boolean(errors?.city)}
              className="dark-outlined-btn"
              onClick={() => handleSubmitButton("draft")}
            >
              Draft
            </MDButton>
            <MDButton
              sx={{ minWidth: "160px", backgroundColor: "#fdd5d3 !important", color: "#FD4438" }}
              type="button"
              variant="outlined"
              color="error"
              className="dark-outlined-btn"
              onClick={() => navigate(-1)}
            >
              Cancel
            </MDButton>

            {/* <MDButton
              sx={{
                minWidth: "92px",
                borderRadius: 1.75,
                minHeight: "28px",
                p: 0.25,
                fontWeight: 500,
              }}
              type="button"
              onClick={() => setFormData({ ...formData, status: "published" })}
              variant={formData?.status === "published" ? "contained" : "text"}
              color={formData?.status === "published" ? "success" : "dark"}
              size="small"
            >
              Published
            </MDButton> */}
            {/* <MDButton
              sx={{
                minWidth: "92px",
                borderRadius: 1.75,
                minHeight: "28px",
                p: 0.25,
                fontWeight: 500,
              }}
              type="button"
              onClick={() => setFormData({ ...formData, status: "draft" })}
              variant={formData?.status === "draft" ? "contained" : "text"}
              color={formData?.status === "draft" ? "success" : "dark"}
              size="small"
            >
              Draft
            </MDButton> */}
          </Stack>
        </Box>
      </Grid>
      {/* )} */}
    </CommonLayout>
  );
}

const GridValidation = React.memo(
  ({ card, gridConfigs, cardId, onError }) => {
    const [prevCard, setPrevCard] = React.useState(null);

    // Only run validation when card or its dependencies change
    React.useEffect(() => {
      if (!card?.layoutType) {
        onError(cardId, "");
        return;
      }

      // Skip if card hasn't changed
      if (JSON.stringify(prevCard) === JSON.stringify(card)) {
        return;
      }

      const currentConfig = gridConfigs.find((conf) => conf.key === card.layoutType);
      if (!currentConfig) {
        onError(cardId, "");
        return;
      }

      const requiredImages = currentConfig.value;
      const desktopImageCount = Array.isArray(card?.desktopGrid)
        ? card.desktopGrid.filter((img) => img?.imageUrl).length
        : 0;
      const mobileImageCount = Array.isArray(card?.mobileGrid)
        ? card.mobileGrid.filter((img) => img?.imageUrl).length
        : 0;

      if (desktopImageCount < requiredImages) {
        onError(cardId, "All desktop images are required");
      } else if (mobileImageCount < requiredImages) {
        onError(cardId, "All mobile images are required");
      } else {
        onError(cardId, "");
      }

      setPrevCard(card);
    }, [card, gridConfigs, cardId, onError, prevCard]);

    return null;
  },
  (prevProps, nextProps) => {
    // Custom comparison function for React.memo
    return (
      JSON.stringify(prevProps.card) === JSON.stringify(nextProps.card) &&
      JSON.stringify(prevProps.gridConfigs) === JSON.stringify(nextProps.gridConfigs) &&
      prevProps.cardId === nextProps.cardId
    );
  }
);
